import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Facebook } from 'lucide-react';
import { contactInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="bg-zinc-900 text-gray-400 border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          {/* Company Name */}
          <div className="flex items-center space-x-3">
            <img 
              src="/kingdom-logo.svg"
              alt="Kingdom Auto Detailing"
              className="h-12 w-auto"
            />
            <span className="text-white font-semibold">Kingdom Auto Detailing</span>
          </div>

          {/* Address */}
          <div className="flex items-center space-x-2">
            <MapPin size={20} className="text-amber-500" />
            <span className="text-sm">{contactInfo.address}, {contactInfo.city}</span>
          </div>

          {/* Contact Links */}
          <div className="flex space-x-6">
            <a
              href={`mailto:${contactInfo.email}`}
              className="flex items-center space-x-2 hover:text-amber-500 transition-colors"
              aria-label="Email"
            >
              <Mail size={20} />
              <span className="text-sm hidden sm:inline">Email</span>
            </a>
            <a
              href="https://wa.me/message/EPE5IIJCJKCAL1"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 hover:text-amber-500 transition-colors"
              aria-label="WhatsApp"
            >
              <Phone size={20} />
              <span className="text-sm hidden sm:inline">WhatsApp</span>
            </a>
            <a
              href={`https://maps.google.com/maps?q=${encodeURIComponent(contactInfo.address + ', ' + contactInfo.city)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 hover:text-amber-500 transition-colors"
              aria-label="Location"
            >
              <MapPin size={20} />
              <span className="text-sm hidden sm:inline">Map</span>
            </a>
          </div>
        </div>

        {/* Social Media Links */}
        <div className="mt-6 flex justify-center space-x-6 border-t border-zinc-800 pt-6">
          <a
            href="https://www.facebook.com/p/Kingdom-Auto-Detailing-100092170133997/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2 hover:text-amber-500 transition-colors group"
            aria-label="Facebook"
          >
            <Facebook size={24} className="group-hover:scale-110 transition-transform" />
            <span className="text-sm font-medium">Facebook</span>
          </a>
        </div>

        {/* Copyright */}
        <div className="mt-6 text-center text-sm border-t border-zinc-800 pt-6">
          <p>© {new Date().getFullYear()} Kingdom Auto Detailing. All rights reserved.</p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;